var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"com-login",class:{ show: _vm.show },on:{"click":function($event){$event.stopPropagation();_vm.show = false}}},[_c('div',{on:{"click":function($event){$event.stopPropagation();}}},[(_vm.show)?_c(_vm.curShow,{tag:"component",on:{"close":function($event){_vm.show = false},"jump":_vm.jump}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }